import { render } from "./ticketDetailView.vue?vue&type=template&id=0c7deed6&scoped=true"
import script from "./ticketDetailView.vue?vue&type=script&lang=js"
export * from "./ticketDetailView.vue?vue&type=script&lang=js"

import "./ticketDetailView.vue?vue&type=style&index=0&id=0c7deed6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7deed6"]])

export default __exports__